/**
 * 全局覆盖 <router-link>，让站内链接自动跟随当前语言。
 *
 * 全站有 58 处 <router-link to="/photoshop">。改成路径化 i18n 之后，英文访客在
 * /en 下点这些链接会被带回中文页，语言就断了。与其逐个改调用点（还容易漏掉动态
 * 绑定的 :to），不如在这里统一加前缀：位于 /en 时，站内路径自动变成 /en/...。
 *
 * 只处理站内相对路径。外链、锚点、已经带 /en 前缀的路径都原样放行。
 */
import Vue from 'vue'

const EN_PREFIX = '/en'

function isInternalPath(p) {
  return typeof p === 'string' && p.startsWith('/') && !p.startsWith('//')
}

function localizePath(path, locale) {
  if (locale !== 'en' || !isInternalPath(path)) return path
  if (path === EN_PREFIX || path.startsWith(EN_PREFIX + '/')) return path
  return path === '/' ? EN_PREFIX : EN_PREFIX + path
}

function localizeTo(to, locale) {
  if (locale !== 'en' || !to) return to
  if (typeof to === 'string') return localizePath(to, locale)
  if (typeof to === 'object') {
    // 具名路由：路由表里英文那套的 name 统一是 en- 前缀
    if (to.name && !String(to.name).startsWith('en-')) {
      return { ...to, name: `en-${to.name}` }
    }
    if (to.path) return { ...to, path: localizePath(to.path, locale) }
  }
  return to
}

export default function installLocalizedLink() {
  const Original = Vue.component('RouterLink')
  if (!Original) return

  const Localized = {
    name: 'RouterLink',
    functional: true,
    props: { ...Original.options.props },
    render(h, ctx) {
      // 语言取自当前 URL，与 seo.js / main.js 的判定保持一致
      const locale = ctx.parent.$route && /^\/en(\/|$)/.test(ctx.parent.$route.path) ? 'en' : 'zh'
      const props = { ...ctx.props, to: localizeTo(ctx.props.to, locale) }
      return h(Original, { ...ctx.data, props }, ctx.children)
    }
  }

  Vue.component('RouterLink', Localized)
  Vue.component('router-link', Localized)
}

export { localizePath, localizeTo }
